import revive_payload_client_MfgsbXVQjy from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_PfB6LIYXUj from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_OoUi1naYZI from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_OJG9mBCHof from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_dTmu4enwuj from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_DcHMRqOAUX from "/app/node_modules/.pnpm/nuxt-gtag@1.1.2/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import plugin_fUEvfpaGmZ from "/app/node_modules/.pnpm/@nuxtjs+device@3.1.1/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import element_plus_teleports_plugin_h4Dmekbj62 from "/app/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/app/.nuxt/element-plus-injection.plugin.mjs";
import chunk_reload_client_LX8jY1Y8xG from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_nvxblnrrsqkwmkwcggizsott3q/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import Directives_Y3R0jDMkKf from "/app/plugins/Directives.ts";
import _01_httpsTrans_client_ECl67D1UWH from "/app/plugins/01.httpsTrans.client.ts";
import _02_console_client_iOANHOJ8zn from "/app/plugins/02.console.client.ts";
import _03_init_userinfo_mW04kEtE7L from "/app/plugins/03.init-userinfo.ts";
import _04_apm_init_client_viPUIZ2ooQ from "/app/plugins/04.apm-init.client.ts";
import _05_monitor_client_OC6tmzLmz8 from "/app/plugins/05.monitor.client.ts";
import _06_broadcast_channel_client_qSAW1H4hxB from "/app/plugins/06.broadcast-channel.client.ts";
import i18n_VfGcjrvSkj from "/app/plugins/i18n.ts";
import vueInject_Ziqt4cDYEQ from "/app/plugins/vueInject.ts";
export default [
  revive_payload_client_MfgsbXVQjy,
  unhead_PfB6LIYXUj,
  router_OoUi1naYZI,
  payload_client_OJG9mBCHof,
  components_plugin_KR1HBZs4kY,
  prefetch_client_dTmu4enwuj,
  plugin_client_DcHMRqOAUX,
  plugin_fUEvfpaGmZ,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  chunk_reload_client_LX8jY1Y8xG,
  Directives_Y3R0jDMkKf,
  _01_httpsTrans_client_ECl67D1UWH,
  _02_console_client_iOANHOJ8zn,
  _03_init_userinfo_mW04kEtE7L,
  _04_apm_init_client_viPUIZ2ooQ,
  _05_monitor_client_OC6tmzLmz8,
  _06_broadcast_channel_client_qSAW1H4hxB,
  i18n_VfGcjrvSkj,
  vueInject_Ziqt4cDYEQ
]